import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  BookWidgetFieldInfoTypes,
  BookWidgetFieldUpdateTypes
} from '../../../../constants/book-widget.constants';

import {
  BestFareOptionsMachCoreComponent,
  ConnectionPickerMachCoreComponent,
  DatePickerMachCoreComponent,
  MeetingCodeMachCoreComponent,
  MulticityRoutePickerMachCoreComponent,
  OneWayRoutePickerMachCoreComponent,
  OptionsExpanderMachCoreComponent,
  SelectMachCoreComponent
} from '../../../common';

import { DropdownItem } from '@com-delta-omnichannel/mach-core-js';
import { BookWidgetFieldUpdateEvent } from '../../../../models/book-widget-fields-update-info.interfaces';
import { SelectedRange } from '../../../../models/common.interfaces';
import {
  SearchModalEvent,
  SearchModalEventType
} from '../../../../models/search-modal-events-object.interface';
import { HomeBookWidgetBaseComponent } from '../home-book-widget-base/home-book-widget-base.component';
@Component({
  standalone: true,
  selector: 'idp-multi-city-mobile-home',
  templateUrl: './multi-city-mobile-home.component.html',
  imports: [
    CommonModule,
    BestFareOptionsMachCoreComponent,
    ConnectionPickerMachCoreComponent,
    DatePickerMachCoreComponent,
    OneWayRoutePickerMachCoreComponent,
    MulticityRoutePickerMachCoreComponent,
    SelectMachCoreComponent,
    OptionsExpanderMachCoreComponent,
    MeetingCodeMachCoreComponent
  ]
})
export class MulticityMobileHomeComponent extends HomeBookWidgetBaseComponent {
  protected showAdvanceOptionsButton = true;

  infoIconClickHandler(sourceIcon: BookWidgetFieldInfoTypes, event: Event) {
    if (sourceIcon) {
      this.handleTooltipAnalytics(sourceIcon, event);
      this.infoIconClick.emit(sourceIcon);
    }
  }

  onViewSearchOptionsHandler() {
    this.viewSearchOptionEvent.emit();
  }

  onDropdownSelectionChange(
    event: DropdownItem,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: event.value,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  onDateSelectionChange(
    selectedRange: SelectedRange,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes,
    flightIndex: number
  ) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: {
        selectedRange,
        flightIndex
      },
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  onToggleChange(
    event: Event,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const target = event.target as HTMLInputElement;
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: target.checked,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  onInputFieldChange(
    event: Event,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const target = event.target as HTMLInputElement;
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: target.value,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  clearConnectionAirport(flightIndex: number) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: {
        airportCode: '',
        airportCity: '',
        flightIndex
      },
      type: BookWidgetFieldUpdateTypes.connectionAirport
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  expandSearchView(event: SearchModalEvent<SearchModalEventType>) {
    if (!this.viewSearchOptionExpanded && event.type === 'modalClose') {
      this.onViewSearchOptionsHandler();
    }
  }
}
